module.exports = __webpack_public_path__ + "img/paginationleft.b905b1a5.svg";